import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

editCardModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        border-radius: 0px;
        padding: 10px 34px;
        background: ${getColor("common.background")};
        border: 2px solid ${getColor("primary")} !important;
        &:hover {
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("text.accent")} !important;
        }

        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            &:hover {
                color: ${getColor("text.accent")};
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
            ])}
    `,
};
editCardModalStyles.saveButton = {
    css: css`
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
};
editCardModalStyles.makeDefaultCardGridItem = {
    width: 12,
    css: css`
        color: ${getColor("text.main")};
    `,
};
editCardModalStyles.cardNicknameGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.cardNumberGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.nameOnCardGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.expirationMonthGridItem = {
    width: [8, 7, 8, 8, 8],
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};

editCardModalStyles.useBillToAddressGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            color: ${getColor("text.main")} !important;
        }
    `,
};
editCardModalStyles.address1TextFieldGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.address2TextFieldGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.address3TextFieldGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.address4TextFieldGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.countryGridItem = {
    width: 8,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.stateGridItem = {
    width: 4,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.cityGridItem = {
    width: [8, 6, 8, 8, 8],
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
editCardModalStyles.postalCodeGridItem = {
    width: [4, 6, 4, 4, 4],
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};